import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore/lite";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import {
  getFunctions
} from "firebase/functions";
const firebaseConfig = {
  apiKey: "AIzaSyCQgkDoDedlLicg0IrRAq3bqEQEv9pUxE8",
  authDomain: "pec-eps-4819c.firebaseapp.com",
  projectId: "pec-eps-4819c",
  storageBucket: "pec-eps-4819c.appspot.com",
  messagingSenderId: "1070723427847",
  appId: "1:1070723427847:web:3745c1e7bfd56226d904a2",
  measurementId: "G-Y30KRT0PKQ"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDK7J4Y8voQw73xy3JfkFlUA9TdLAC5yAo",
//   authDomain: "practice-da156.firebaseapp.com",
//   databaseURL: "https://practice-da156.firebaseio.com",
//   projectId: "practice-da156",
//   storageBucket: "practice-da156.appspot.com",
//   messagingSenderId: "986416532257",
//   appId: "1:986416532257:web:5adf844fc848ab31324c60",
//   measurementId: "G-H9CMZN3ZQR",
// };

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app, "asia-east1");
export { app, db, auth, storage ,functions};
